/**
 * 连续自然日同名事件合并（与 overview 接口侧 merge 算法一致），用于 KPI 图表区 EventWindows，
 * 避免同一事件在多日重复出现多个浮动标签。X 轴数字气泡与底部 EventDetailsPop 仍用未合并数据。
 */
import { mergeTrendEventListConsecutiveDays } from '@/pages/dashboard/servicesModels/overview/mergeTrendEventListConsecutiveDays';
import { buildPropsEventDataFromEventList } from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiEventMetricTrendService/_utils';
import type { EventDataMap } from './types';

function ymdKeyToIsoDate(key: string): string {
  const s = String(key ?? '').trim();
  if (/^\d{8}$/.test(s)) {
    return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
  }
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    return s.slice(0, 10);
  }
  return s;
}

export function mergeConsecutiveTrendDaysOnEventDataMap(
  map: EventDataMap | undefined,
): EventDataMap | undefined {
  if (!map || Object.keys(map).length === 0) {
    return map;
  }
  const keys = Object.keys(map).sort((a, b) =>
    ymdKeyToIsoDate(a).localeCompare(ymdKeyToIsoDate(b)),
  );
  const list = keys.map(k => {
    const items = map[k];
    const arr = Array.isArray(items) ? items : [];
    const iso = ymdKeyToIsoDate(k);
    return {
      date: iso,
      events: arr.length,
      event_list:
        arr.length > 0
          ? [{ events: arr.length, event_record: arr as unknown[] }]
          : [],
    };
  });
  const merged = mergeTrendEventListConsecutiveDays(list);
  const built = buildPropsEventDataFromEventList(merged);
  return built.eventData;
}
